import React, { Fragment, useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import SweetAlert from 'sweetalert2';
import axioInstance from '../axiosInstance';
import SideImg from '../../img/Protection.png';
import formatAmount from 'indian-currency-formatter';
import { sanitizeNumber, formatDigitAmount } from '../global';

export default function CashflowScreen4({ setSubstep, substep, nextsubStep, StepChange, steps, nextStep, prevsubStep, clientName }) {

  const { register, handleSubmit, formState: { errors, isDirty, isValid }, setValue, trigger } = useForm();
  const [loanData, setLoanData] = useState([]); // Stores final property list (default + API)
  const [buttonSpinner, setButtonSpinner] = useState(false);


  // Default property list
  const defaultLoans = [
    { id: 1, loanName: "Home Loan", subType: "1", checked: true },
    { id: 2, loanName: "Car Loan", subType: "2", checked: true },
    { id: 3, loanName: "Personal Loan", subType: "3", checked: true },
    { id: 4, loanName: "Other Loan", subType: "6", checked: true }
  ];



  useEffect(() => {
    const profile_id = sessionStorage.getItem("profile_id").replace(" ", '');

    axioInstance.post(`prof-liability/get`, { profile_id })
      .then((response) => {
        if (response.data.length > 0) {


          setLoanData(response.data); // Use API response if available

          response.data.forEach((loans, index) => {


            setValue(`loanArr.${index}.InstrName`, loans.instr_name || '');
            setValue(`loanArr.${index}.liability_id`, loans.liability_id ?? '', { shouldDirty: true, shouldValidate: true });
            setValue(`loanArr.${index}.subType`, loans.sub_type || '');
            setValue(`loanArr.${index}.Amount`, formatDigitAmount(loans.loan_amount) || '', { shouldDirty: true, shouldValidate: true });
            setValue(`loanArr.${index}.AmountType`, loans.loan_amount >= 10000000 ? "10000000" : "100000");
            setValue(`loanArr.${index}.Outstanding`, formatDigitAmount(loans.outstanding_loan) || '');
            setValue(`loanArr.${index}.OutstandingType`, loans.outstanding_loan >= 10000000 ? "10000000" : "100000");
            setValue(`loanArr.${index}.Emi`, formatAmount(loans.emi) || '');

          });

          trigger();
        } else {
          setLoanData(defaultLoans); // If API returns empty, use default properties
        }
      })
      .catch(() => {
        setLoanData(defaultLoans); // In case of error, use defaults
      });
    // eslint-disable-next-line
  }, [setValue, trigger]);

  const handleChange = (e) => {
    setValue(e.target.name, formatAmount(sanitizeNumber(e.target.value)));
  };


  const skipStep = () => {

    axioInstance.post(`profile/update-stepper`, { profile_id: sessionStorage.getItem('profile_id'), 'admin_id': sessionStorage.getItem('admin_id'), step: steps + 1 }).then(function (response, data) {
      StepChange(nextStep(steps));
    });

  }

  const onSubmit = async (data) => {
    setButtonSpinner(true);
    const profile_id = sessionStorage.getItem('profile_id');
    const profile_details_id = sessionStorage.getItem('profile_details_id');

    try {
      const PostData = {
        profile_id,
        profile_details_id,
        loans: data.loanArr
      };

      const response = await axioInstance.post(`profile/add-liabilities`, PostData);

      if (response.data.status === 100) {

        axioInstance.post(`profile/update-stepper`, { profile_id: sessionStorage.getItem('profile_id'), 'admin_id': sessionStorage.getItem('admin_id'), step: steps + 1 }).then(function (response, data) {
          setButtonSpinner(false);
          StepChange(nextStep(steps));
        });

      } else {
        SweetAlert.fire(
          'Loan',
          'Failed. Something went wrong. Retry again',
          'error'
        )
      }
    } catch (error) {
      SweetAlert.fire(
        'Loan',
        'Failed. Something went wrong. Retry again',
        'error'
      )
    } finally {
      setButtonSpinner(false);
    }
  };


  return (
    <Fragment>

      <div className="mainwrapper">
        <div className="form_title">
          <div className="mt30 font20 fw600">{clientName} Cashflow</div>
          <div className="font15 color495">we need to map a plan to match your goals. so we need your income infos</div>
        </div>

        <div className="row formWpr mt25">
          <div className="col-lg-8 formouter">
            <ul className="form_swipe_tab font12 fw600">
              <li>1</li>
              <li>2</li>
              <li onClick={() => setSubstep(prevsubStep(substep))}>3</li>
              <li className="act">4</li>
            </ul>

            <form className="custome_form" onSubmit={handleSubmit(onSubmit)}>

              <div className="formtitle flex_center justify_center">
                <div>
                  <div className="font20 fw600">Loans</div>
                  <div className="font15 color495 ">Also a bit approximate idea about your commitments</div>
                </div>
                <div>

                  <button type={buttonSpinner ? "button" : "submit"} className="bluebtn font13 fw600 d-none d-md-block" disabled={!isDirty && !isValid}>{buttonSpinner ? <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> loading</> : "Save"}
                    <span className="whitearrow"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 9C2.25217 7.6 3.26957 6.54783 4.87826 5.29565C5.06957 5.14783 5.06957 4.85217 4.87826 4.70435C3.26957 3.45217 2.25217 2.4 1 1" stroke="white" strokeWidth="1.30435" strokeMiterlimit="10" />
                    </svg></span></button>
                </div>
              </div>

              {/* Form */}

              <div className="p35">

                <div className="form-row">


                  <div className="mt25">
                    {/*<div className="font16 color212 fw600">Number of active loans</div>
                    <div className="mt15 quantity_wpr">
                      <button onClick={() => decrement()}>-</button>
                      <input type="text" className="font14 fw500 ml15 mr15" value={loanCount} />
                      <button onClick={() => increment()}>+</button>
                    </div>*/}

                    {
                      loanData.map((e, i) => <>
                        <div className="flex_center justify_center">
                          <div className="entergoalname_wpr widthauto">
                            <div className="entergoalname">
                              <form className="custome_form searchinput">
                                <div className="form-row">
                                  <div className="form-group m0">
                                    <input type="text" className="form-control font14 color212 fw500" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Loan name" name={`loanArr.${i}.InstrName`} defaultValue={e.loanName} {...register(`loanArr.${i}.InstrName`, { required: 'Loan Name is required' })} />
                                    <span className="text-danger"> {errors.loanArr?.[i]?.InstrName?.message}</span>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>

                        <input type="hidden" className="form-control font14 color212 fw500" name={`loanArr.${i}.subType`} {...register(`loanArr.${i}.subType`)} defaultValue={e.subType} />

                        <input type="hidden" className="form-control font14 color212 fw500" name={`loanArr.${i}.liability_id`} {...register(`loanArr.${i}.liability_id`)} />

                        <div className="form_prnt mt20">
                          <div className="form-row justify-content-between">
                            <div className="col-md-4 pr20">
                              <label htmlFor="inputEmail4" className="font14 fw600">Total loan </label>
                              <div className="input-group selectarrow select50">
                                <input type="text" className="form-control font14 color212 fw500" aria-label="Text input with dropdown button" placeholder="Enter" name={`loanArr.${i}.Amount`} {...register(`loanArr.${i}.Amount`)} maxLength={3} minLength={1} />
                                <select className="custom-select" id="inputGroupSelect01" name={`loanArr.${i}.AmountType`} {...register(`loanArr.${i}.AmountType`)}>
                                  <option selected value="100000">Lakhs</option>
                                  <option value="10000000">Crore</option>
                                </select>
                                <span className="rupicon rupeesign font14 fw500">&#8377;</span>
                              </div>
                            </div>
                            <div className="col-md-4 pl20">
                              <label htmlFor="inputEmail4" className="font14 fw600">EMI </label>
                              <div className="input-group inputround">
                                <input type="text" className="form-control font14 color212 fw500" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter" name={`loanArr.${i}.Emi`} {...register(`loanArr.${i}.Emi`)} maxLength={10} minLength={1} onChange={handleChange}></input>
                                <span className="rupicon rupeesign font14 fw500">&#8377;</span>
                              </div>
                            </div>
                            <div className="col-md-4 pl20">
                              <label htmlFor="inputEmail4" className="font14 fw600">Remaining loan </label>
                              <div className="input-group selectarrow select50">
                                <input type="text" className="form-control font14 color212 fw500" aria-label="Text input with dropdown button" placeholder="Enter" name={`loanArr.${i}.Outstanding`} {...register(`loanArr.${i}.Outstanding`)} maxLength={3} minLength={1} />
                                <select className="custom-select" id="inputGroupSelect01" name={`loanArr.${i}.OutstandingType`} {...register(`loanArr.${i}.OutstandingType`)}>
                                  <option selected value="100000">Lakhs</option>
                                  <option value="10000000">Crore</option>
                                </select>
                                <span className="rupicon rupeesign font14 fw500">&#8377;</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {i <= 2 ? <div className="formdevider mt35 mb35" /> : ""}

                      </>)
                    }
                  </div>
                </div>
              </div>

              <div className="saveBtn backsaveBtn d-block d-sm-none">
                <button type="button" className="btn btn-primary" onClick={() => setSubstep(prevsubStep(substep))}> Back </button>
                <button type={buttonSpinner ? "button" : "submit"} disabled={!isDirty && !isValid} className="btn btn-primary"> {buttonSpinner ? <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> loading</> : "Save"} </button>
              </div>

            </form>

            {/* Form End */}

            <div className='pr-5'>


              <div className="mob_left_right mb5" style={{ 'text-align': 'center' }}>
                <button type="button" className="btn bluebtn backtowizardBtn font13 fw600" onClick={() => skipStep()}>Skip Loans</button>
              </div>

            </div>

          </div>

          <div className="col-lg-4 qouteouter d-none d-md-block">
            <div className="qoutetext font18 fw500 color212 pl45 pr45">
              <div className="qoutesign">
                &#8220;
              </div>
              If you have other loan, please click add loan button and add them.
            </div>


            <div className="qouteimg" ><img src={SideImg} alt='Protection' /></div>
          </div>
        </div>

      </div>
    </Fragment>
  )
}
